import { Theme } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";

export const SCHEDULING_ROW_HEIGHT = 140;

export default makeStyles((theme: Theme) => ({
  root: {
    height: SCHEDULING_ROW_HEIGHT
  },
  datesList: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    transform: "translateZ(0)",
    overflowX: "auto",
    paddingTop: 16,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 12,
    overflowY: "hidden",
    width: "100%",
    minHeight: 92,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 16,
      paddingRight: 16
    }
  },
  lock: {
    pointerEvents: "none"
  },
  monthGroup: {
    display: "flex",
    "&:last-child": {
      "& > div:last-child": {
        marginRight: 0
      }
    }
  },
  monthDivider: {
    width: 12,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
    marginRight: 8
  },
  monthDividerText: {
    color: theme.palette.text.hint,
    transform: "rotate(270deg)",
    fontSize: 10,
    lineHeight: "normal",
    textTransform: "uppercase"
  },
  noSchedule: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.hint
  },
  scheduleDate: {
    animationName: "$show-day",
    animationDuration: "0.3s",
    animationFillMode: "both"
  },
  freeDate: {},
  skipAnimation: {
    "& $freeDate": {
      animationDuration: "0s"
    }
  },
  scheduledOnly: {
    "& $freeDate": {
      animationName: "$hide-day",
      animationDuration: "0.3s",
      animationFillMode: "both"
    }
  },
  "@keyframes hide-day": {
    "0%": {
      opacity: 1,
      overflow: "hidden",
      width: 60,
      minWidth: 60
    },
    "100%": {
      opacity: 0,
      overflow: "hidden",
      marginRight: 0,
      border: "none",
      width: 0,
      minWidth: 0,
      maxWidth: 0
    }
  },
  "@keyframes show-day": {
    "0%": {
      opacity: 0,
      overflow: "initial",
      border: "none",
      width: 0,
      minWidth: 0
    },
    "100%": {
      opacity: 1,
      overflow: "initial",
      width: 60,
      minWidth: 60
    }
  }
}));
